import styled from 'styled-components'

import InvisibleButton from 'components/display/InvisibleButton'

const CloseButton = styled(InvisibleButton).attrs({ type: 'button' })<{
  $colour?: '-ds-neutral-700' | '-ds-neutral-100' | '-ds-core-400'
  $small?: boolean
}>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: ${({ theme, $colour }) => {
    if ($colour) return theme?.[$colour]?.value
    return theme?.['-ds-core-400']?.value
  }};

  top: 0;
  right: 0;

  width: 64px;
  height: 64px;

  svg {
    width: ${({ $small }) => ($small ? '14px' : '32px')};
    height: ${({ $small }) => ($small ? '14px' : '32px')};
    filter: ${({ $colour }) =>
      $colour === '-ds-neutral-100'
        ? 'drop-shadow(0 0 2px rgba(0, 0, 0, .7))'
        : 'none'};
  }
`

export default CloseButton
